import { FieldsEnum, FormsEnum, SectionsEnum } from 'app/shared/enums';
import {
  clearFieldValue,
  getFormValue,
  setSectionVisibilityHelper,
} from 'app/services/businessFunctionHelpers';

export function setupHomeAddressSectionVisibility({
  homeAddressNotSameAsLegalQuestionKey,
  homeAddressSectionKey,
}: {
  homeAddressNotSameAsLegalQuestionKey: FieldsEnum;
  homeAddressSectionKey: SectionsEnum;
}) {
  const isHomeAddressNotSameAsLegal = getFormValue(
    homeAddressNotSameAsLegalQuestionKey,
    FormsEnum.CheckoutForm
  );

  setSectionVisibilityHelper({
    key: homeAddressSectionKey,
    visible: isHomeAddressNotSameAsLegal,
    formName: FormsEnum.CheckoutForm,
  });
  if (!isHomeAddressNotSameAsLegal) {
    const correspondanceAddress = getFormValue(
      FieldsEnum.CorrespondanceAddress,
      FormsEnum.CheckoutForm
    );
    if (correspondanceAddress === 'owner_homeAddress') {
      clearFieldValue(FieldsEnum.CorrespondanceAddress, FormsEnum.CheckoutForm);
    }
  }
}

export function setupCheckutPaymentSuspendedHomeAddressSectionVisibility({
  homeAddressNotSameAsLegalQuestionKey,
  homeAddressSectionKey,
}: {
  homeAddressNotSameAsLegalQuestionKey: FieldsEnum;
  homeAddressSectionKey: SectionsEnum;
}) {
  const isHomeAddressNotSameAsLegal = getFormValue(
    homeAddressNotSameAsLegalQuestionKey,
    FormsEnum.CheckoutPaymentAlertForm
  );

  setSectionVisibilityHelper({
    key: homeAddressSectionKey,
    visible: isHomeAddressNotSameAsLegal,
    formName: FormsEnum.CheckoutPaymentAlertForm,
  });
}
